import { Box, Tab, Tabs } from "@mui/material";
import { Track } from "@/modules/property-tracks/types";
import { usePropertyTrackTabs } from "@/modules/property-tracks/hooks/property-tracker-tab";

export type PropertyTrackTabOptions =
  | "Activity"
  | "Overview"
  | "Documents"
  | "Construction"
  | "SubProperties"
  | "LinkedTracks"
  | "Listing"
  | "Interests"
  | "Tenants"
  | "DrawingProposals"
  | "CustomerIdInfo";

function DesktopPropertyTrackTabs({ track }: Readonly<{ track?: Track }>) {
  const {
    selectedTab,
    handleTabChange,
    isConstructionTabVisible,
    subPropertiesTabVisible,
    isRentalListingVisible,
    isResaleListingVisible,
    isHospitalityListingVisible,
    isInterestsVisible,
    isTenantsVisible,
    isDrawingProposalsVisible,
  } = usePropertyTrackTabs({ track });

  return (
    <Box
      sx={{
        borderBottom: 1,
        borderBottomColor: "#DEE2E7",
        height: "48px",
        maxHeight: "48px",
        backgroundColor: "white",
      }}
    >
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
      >
        <Tab
          sx={{
            textTransform: "none",
          }}
          label="Activity"
          value="Activity"
        />
        <Tab sx={{ textTransform: "none" }} label="Overview" value="Overview" />
        <Tab
          sx={{ textTransform: "none" }}
          label="Documents"
          value="Documents"
        />
        <Tab
          sx={{ textTransform: "none" }}
          label="Customer ID Info"
          value="CustomerIdInfo"
        />
        {isConstructionTabVisible && (
          <Tab
            sx={{ textTransform: "none" }}
            label="Construction"
            value="Construction"
          />
        )}
        {subPropertiesTabVisible && (
          <Tab
            sx={{ textTransform: "none" }}
            label="Sub-properties"
            value="SubProperties"
          />
        )}
        <Tab
          sx={{ textTransform: "none" }}
          label="Linked Tracks"
          value="LinkedTracks"
        />
        {(isRentalListingVisible || isResaleListingVisible || isHospitalityListingVisible) && (
          <Tab
            sx={{ textTransform: "none" }}
            label="Active Listing"
            value="Listing"
          />
        )}
        {isInterestsVisible && (
          <Tab
            sx={{ textTransform: "none" }}
            label="Interests"
            value="Interests"
          />
        )}

        {isTenantsVisible && (
          <Tab sx={{ textTransform: "none" }} label="Tenants" value="Tenants" />
        )}

        {isDrawingProposalsVisible && (
          <Tab
            sx={{ textTransform: "none" }}
            label="Drawing Proposals"
            value="DrawingProposals"
          />
        )}
      </Tabs>
    </Box>
  );
}

export default DesktopPropertyTrackTabs;
